var _rect, _rect2, _path, _path2, _ellipse, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRateFace4On(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.3,
    y: 0.8,
    width: 30.4,
    height: 30.4,
    rx: 15.2,
    fill: "#FFD8E9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.3,
    y: 0.8,
    width: 30.4,
    height: 30.4,
    rx: 15.2,
    stroke: "#FF77B1",
    strokeWidth: 1.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0586 19.3323C22.1621 19.3322 22.238 19.431 22.2101 19.5306C20.7914 24.5971 12.4283 24.5965 11.1085 19.545",
    fill: "#FF3D8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1085 19.545C12.4283 24.5965 20.7914 24.5971 22.2101 19.5306C22.238 19.431 22.1621 19.3322 22.0586 19.3323L11.2602 19.3492C11.1581 19.3494 11.0827 19.4462 11.1085 19.545Z",
    stroke: "#FF3D8F",
    strokeWidth: 3.2,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.1541,
    cy: 12.1619,
    rx: 2.44122,
    ry: 2.56038,
    fill: "#FF3D8F"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.1697,
    cy: 12.1619,
    rx: 2.44122,
    ry: 2.56038,
    fill: "#FF3D8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRateFace4On);
export default __webpack_public_path__ + "static/media/icon-rate-face-4-on.d3e1f0ca393b153844596cfd0a2e5537.svg";
export { ForwardRef as ReactComponent };